import React, { useEffect, useRef } from 'react';

/* =============================================================
   Landing.js — page d'accueil "Facturation électronique"
   Converti depuis le bloc HTML Elementor.
   ============================================================= */

const FE_STYLES = `
  .fe-block{
    --navy:#0A2540;--navy-2:#0E3A66;--blue:#1D6FB8;--blue-bright:#2E86DE;
    --gold:#C9A227;--gold-soft:#E4C766;--ink:#10233A;--slate:#55677D;
    --bg:#FFFFFF;--bg-soft:#F4F8FC;--line:#E3EAF2;--radius:16px;
    --shadow:0 18px 45px -22px rgba(10,37,64,.35);--maxw:1160px;
    --display:"Space Grotesk",-apple-system,BlinkMacSystemFont,sans-serif;
    --body:"Inter",-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;
    font-family:var(--body);color:var(--ink);line-height:1.6;-webkit-font-smoothing:antialiased;
  }
  .fe-block *{box-sizing:border-box}
  .fe-block a{color:inherit;text-decoration:none}
  .fe-block img{max-width:100%;display:block}
  .fe-block .wrap{max-width:var(--maxw);margin:0 auto;padding:0 24px}
  .fe-block h1,.fe-block h2,.fe-block h3{font-family:var(--display);line-height:1.12;letter-spacing:-.01em;color:var(--navy);margin:0}
  .fe-block p{margin:0}

  .fe-block .eyebrow{display:inline-flex;align-items:center;gap:.55rem;font-family:var(--body);font-weight:600;font-size:.74rem;letter-spacing:.14em;text-transform:uppercase;color:var(--blue)}
  .fe-block .eyebrow::before{content:"";width:26px;height:2px;background:var(--gold);display:inline-block}

  .fe-block .btn{display:inline-flex;align-items:center;justify-content:center;gap:.5rem;font-family:var(--body);font-weight:600;font-size:.98rem;padding:.85rem 1.5rem;border-radius:10px;border:1px solid transparent;cursor:pointer;transition:transform .18s ease,box-shadow .18s ease,background .18s ease}
  .fe-block .btn svg{width:17px;height:17px}
  .fe-block .btn-gold{background:var(--gold);color:var(--navy)}
  .fe-block .btn-gold:hover{background:var(--gold-soft);transform:translateY(-2px)}
  .fe-block .btn-outline-light{background:transparent;color:#fff;border-color:rgba(255,255,255,.4)}
  .fe-block .btn-outline-light:hover{border-color:#fff;background:rgba(255,255,255,.08)}
  .fe-block a:focus-visible,.fe-block button:focus-visible{outline:3px solid var(--gold);outline-offset:2px;border-radius:6px}

  .fe-block .hero{position:relative;overflow:hidden;border-radius:var(--radius);background:radial-gradient(1200px 500px at 80% -10%,rgba(46,134,222,.18),transparent 60%),linear-gradient(160deg,#0A2540 0%,#0E3A66 55%,#134a86 100%);color:#fff}
  .fe-block .hero::after{content:"";position:absolute;inset:0;background-image:linear-gradient(rgba(255,255,255,.04) 1px,transparent 1px),linear-gradient(90deg,rgba(255,255,255,.04) 1px,transparent 1px);background-size:46px 46px;-webkit-mask-image:radial-gradient(120% 90% at 70% 0,#000,transparent 75%);mask-image:radial-gradient(120% 90% at 70% 0,#000,transparent 75%);pointer-events:none}
  .fe-block .hero .wrap{position:relative;z-index:2;padding:72px 40px 80px;max-width:900px}
  .fe-block .hero .eyebrow{color:var(--gold-soft)}
  .fe-block .breadcrumb{font-size:.82rem;color:rgba(255,255,255,.62);margin-bottom:20px;letter-spacing:.02em}
  .fe-block .breadcrumb a:hover{color:#fff}
  .fe-block .hero h1{color:#fff;font-size:clamp(2.1rem,5.2vw,3.5rem);margin:14px 0 18px;max-width:16ch}
  .fe-block .hero h1 em{font-style:normal;color:var(--gold-soft)}
  .fe-block .hero p.lead{font-size:clamp(1.05rem,2.2vw,1.25rem);color:rgba(255,255,255,.82);max-width:56ch;margin-bottom:30px}
  .fe-block .hero-actions{display:flex;flex-wrap:wrap;gap:14px;margin-bottom:34px}
  .fe-block .badges{display:flex;flex-wrap:wrap;gap:10px}
  .fe-block .badge{display:inline-flex;align-items:center;gap:.4rem;font-size:.8rem;font-weight:500;color:rgba(255,255,255,.9);background:rgba(255,255,255,.08);border:1px solid rgba(255,255,255,.16);padding:.4rem .8rem;border-radius:999px}
  .fe-block .badge b{color:var(--gold-soft);font-weight:700}

  .fe-block .sec{padding:76px 0}
  .fe-block .sec-head{max-width:60ch;margin-bottom:40px}
  .fe-block .sec-head h2{font-size:clamp(1.7rem,3.6vw,2.4rem);margin:14px 0 12px}
  .fe-block .sec-head p{color:var(--slate);font-size:1.06rem}
  .fe-block .goldline{width:54px;height:3px;background:var(--gold);border-radius:2px}
  .fe-block .bg-soft{background:var(--bg-soft);border-radius:var(--radius)}

  .fe-block .context-grid{display:grid;grid-template-columns:1.1fr .9fr;gap:48px;align-items:center}
  .fe-block .context-note{background:#fff;border:1px solid var(--line);border-left:4px solid var(--gold);border-radius:12px;padding:24px 26px;box-shadow:var(--shadow)}
  .fe-block .context-note h3{font-size:1.05rem;margin-bottom:8px}
  .fe-block .context-note p{color:var(--slate);font-size:.96rem}
  .fe-block .context-grid .lead-col p{color:var(--slate);font-size:1.05rem;margin-top:8px}
  .fe-block .context-grid strong{color:var(--ink)}

  .fe-block .cards{display:grid;grid-template-columns:repeat(3,1fr);gap:22px}
  .fe-block .card{background:#fff;border:1px solid var(--line);border-radius:var(--radius);padding:28px;transition:transform .2s ease,box-shadow .2s ease,border-color .2s}
  .fe-block .card:hover{transform:translateY(-4px);box-shadow:var(--shadow);border-color:transparent}
  .fe-block .card .ico{width:46px;height:46px;border-radius:11px;display:grid;place-items:center;background:linear-gradient(150deg,var(--blue),var(--navy-2));color:#fff;margin-bottom:16px}
  .fe-block .card .ico svg{width:22px;height:22px}
  .fe-block .card h3{font-size:1.12rem;margin-bottom:8px}
  .fe-block .card p{color:var(--slate);font-size:.95rem}

  .fe-block .why{display:grid;grid-template-columns:1fr 1fr;gap:48px;align-items:center}
  .fe-block .why .lead-col p{color:var(--slate);font-size:1.05rem}
  .fe-block .why ul{list-style:none;margin:22px 0 0;padding:0;display:grid;gap:14px}
  .fe-block .why li{display:flex;gap:12px;align-items:flex-start;font-size:1rem;color:var(--ink)}
  .fe-block .why li svg{flex:0 0 auto;width:22px;height:22px;color:var(--blue);margin-top:2px}
  .fe-block .why-panel{background:linear-gradient(160deg,var(--navy),var(--navy-2));border-radius:20px;padding:36px;color:#fff;box-shadow:var(--shadow)}
  .fe-block .why-panel h3{color:#fff;font-size:1.25rem;margin-bottom:8px}
  .fe-block .why-panel p{color:rgba(255,255,255,.78);font-size:.96rem;margin-bottom:24px}
  .fe-block .logos-row{display:flex;flex-wrap:wrap;gap:10px}
  .fe-block .chip{font-size:.82rem;font-weight:600;color:#fff;background:rgba(255,255,255,.1);border:1px solid rgba(255,255,255,.18);padding:.4rem .85rem;border-radius:8px}

  .fe-block .aud{display:grid;grid-template-columns:repeat(4,1fr);gap:20px}
  .fe-block .aud .card{padding:24px}
  .fe-block .aud .ico{background:linear-gradient(150deg,var(--gold),#b8901f)}
  .fe-block .aud .ico svg{color:var(--navy)}

  .fe-block .steps{display:grid;grid-template-columns:repeat(3,1fr);gap:24px;counter-reset:step}
  .fe-block .step{position:relative;padding:30px 26px 26px;background:#fff;border:1px solid var(--line);border-radius:var(--radius)}
  .fe-block .step::before{counter-increment:step;content:"0" counter(step);font-family:var(--display);font-weight:700;font-size:2rem;color:var(--gold);display:block;margin-bottom:12px;line-height:1}
  .fe-block .step h3{font-size:1.1rem;margin-bottom:8px}
  .fe-block .step p{color:var(--slate);font-size:.95rem}

  .fe-block .cta-band{border-radius:var(--radius);background:radial-gradient(900px 400px at 15% 120%,rgba(201,162,39,.22),transparent 60%),linear-gradient(150deg,var(--navy),var(--navy-2));color:#fff;text-align:center}
  .fe-block .cta-band .wrap{padding:70px 24px}
  .fe-block .cta-band h2{color:#fff;font-size:clamp(1.7rem,3.8vw,2.5rem);margin:14px 0}
  .fe-block .cta-band p{color:rgba(255,255,255,.82);max-width:52ch;margin:0 auto 28px;font-size:1.08rem}
  .fe-block .cta-band .hero-actions{justify-content:center}

  .fe-block .reveal{opacity:0;transform:translateY(18px);transition:opacity .6s ease,transform .6s ease}
  .fe-block .reveal.in{opacity:1;transform:none}

  .fe-block .pricing{display:grid;grid-template-columns:repeat(4,1fr);gap:20px;align-items:stretch}
  .fe-block .price-card{position:relative;display:flex;flex-direction:column;background:#fff;border:1px solid var(--line);border-radius:var(--radius);padding:28px 24px;transition:transform .2s ease,box-shadow .2s ease,border-color .2s}
  .fe-block .price-card:hover{transform:translateY(-4px);box-shadow:var(--shadow)}
  .fe-block .price-card.popular{border:2px solid var(--gold);box-shadow:var(--shadow)}
  .fe-block .price-badge{position:absolute;top:-13px;left:50%;transform:translateX(-50%);background:var(--gold);color:var(--navy);font-family:var(--body);font-weight:700;font-size:.72rem;letter-spacing:.06em;text-transform:uppercase;padding:.32rem .9rem;border-radius:999px;white-space:nowrap}
  .fe-block .price-tier{font-family:var(--display);font-weight:700;font-size:1.25rem;color:var(--navy);margin-bottom:4px}
  .fe-block .price-tier-sub{font-size:.85rem;color:var(--slate);min-height:2.6em;margin-bottom:16px}
  .fe-block .price-amount{display:flex;align-items:baseline;gap:6px;margin-bottom:2px}
  .fe-block .price-amount .num{font-family:var(--display);font-weight:700;font-size:2.3rem;color:var(--navy);line-height:1}
  .fe-block .price-amount .cur{font-family:var(--display);font-weight:600;font-size:1rem;color:var(--navy)}
  .fe-block .price-period{font-size:.82rem;color:var(--slate);margin-bottom:6px}
  .fe-block .price-quota{font-size:.9rem;color:var(--ink);font-weight:600;padding:8px 0 4px;border-top:1px solid var(--line);margin-top:14px}
  .fe-block .price-over{font-size:.8rem;color:var(--slate);margin-bottom:18px}
  .fe-block .price-feats{list-style:none;margin:0 0 22px;padding:0;display:grid;gap:10px;flex:1}
  .fe-block .price-feats li{display:flex;gap:9px;align-items:flex-start;font-size:.88rem;color:var(--ink);line-height:1.4}
  .fe-block .price-feats li svg{flex:0 0 auto;width:17px;height:17px;margin-top:2px;color:var(--blue)}
  .fe-block .price-feats li.off{color:#9fb0c2}
  .fe-block .price-feats li.off svg{color:#c7d3df}
  .fe-block .price-feats li b{color:var(--navy)}
  .fe-block .price-card .btn{width:100%}
  .fe-block .btn-navy{background:var(--navy);color:#fff}
  .fe-block .btn-navy:hover{background:var(--navy-2);transform:translateY(-2px)}
  .fe-block .btn-outline{background:transparent;color:var(--navy);border-color:var(--line)}
  .fe-block .btn-outline:hover{border-color:var(--blue);color:var(--blue)}
  .fe-block .pricing-note{text-align:center;font-size:.85rem;color:var(--slate);margin-top:26px;max-width:64ch;margin-left:auto;margin-right:auto}

  @media(max-width:960px){
    .fe-block .cards,.fe-block .aud{grid-template-columns:repeat(2,1fr)}
    .fe-block .context-grid,.fe-block .why{grid-template-columns:1fr;gap:32px}
    .fe-block .steps{grid-template-columns:1fr}
    .fe-block .pricing{grid-template-columns:repeat(2,1fr)}
    .fe-block .price-card.popular{transform:none}
  }
  @media(max-width:760px){
    .fe-block .sec{padding:52px 0}
    .fe-block .cards,.fe-block .aud{grid-template-columns:1fr}
    .fe-block .pricing{grid-template-columns:1fr;max-width:380px;margin:0 auto}
    .fe-block .price-tier-sub{min-height:0}
    .fe-block .hero .wrap{padding:52px 24px 60px}
  }
  @media(prefers-reduced-motion:reduce){
    .fe-block .reveal{opacity:1;transform:none;transition:none}
    .fe-block .btn:hover,.fe-block .card:hover,.fe-block .price-card:hover{transform:none}
  }
`;

const FE_HTML = `
  <!-- HERO -->
  <div class="hero">
    <div class="wrap">
      <div class="breadcrumb"><a href="https://logimes.com/">Accueil</a> &nbsp;\u203a&nbsp; Services utiles &nbsp;\u203a&nbsp; Facturation \u00e9lectronique</div>
      <span class="eyebrow">Conformit\u00e9 fiscale \u00b7 Tunisie</span>
      <h1>Facturation \u00e9lectronique conforme <em>El Fatoora &amp; TTN</em></h1>
      <p class="lead">\u00c9mettez, signez et transmettez vos factures au format l\u00e9gal tunisien (TEIF) en quelques clics. Une plateforme con\u00e7ue par LOGIMES, l'expert de l'int\u00e9gration ERP&nbsp;/&nbsp;MES.</p>
      <div class="hero-actions">
        <a class="btn btn-gold" href="http://das-cloud.com/login" target="_blank" rel="noopener">
          Acc\u00e9der \u00e0 la plateforme
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M7 17L17 7M17 7H8M17 7v9"/></svg>
        </a>
        <a class="btn btn-outline-light" href="https://meetings-eu1.hubspot.com/meetings/mohamed-louati" target="_blank" rel="noopener">Demander une d\u00e9mo</a>
      </div>
      <div class="badges">
        <span class="badge"><b>\u25c6</b> Format TEIF</span>
        <span class="badge"><b>\u25c6</b> Plateforme TTN / El Fatoora</span>
        <span class="badge"><b>\u25c6</b> Signature TunTrust</span>
        <span class="badge"><b>\u25c6</b> Connecteur ERP</span>
      </div>
    </div>
  </div>

  <!-- CONTEXTE -->
  <div class="sec">
    <div class="wrap">
      <div class="context-grid">
        <div class="lead-col reveal">
          <span class="eyebrow">Le contexte</span>
          <h2 style="font-size:clamp(1.6rem,3.4vw,2.2rem);margin:14px 0 4px">Pourquoi passer \u00e0 la facture \u00e9lectronique</h2>
          <div class="goldline" style="margin:8px 0 18px"></div>
          <p>En Tunisie, la facturation \u00e9lectronique s'impose progressivement comme le standard l\u00e9gal. Les entreprises assujetties \u00e0 la TVA doivent \u00e9mettre leurs factures au format normalis\u00e9 <strong>TEIF</strong>, les transmettre via la plateforme <strong>El Fatoora de la TTN (Tunisie TradeNet)</strong> et les s\u00e9curiser par une <strong>signature \u00e9lectronique certifi\u00e9e</strong>.</p>
          <p>Se mettre en conformit\u00e9, c'est \u00e9viter les rejets, s\u00e9curiser sa relation avec l'administration fiscale et gagner un temps consid\u00e9rable sur le traitement documentaire.</p>
        </div>
        <div class="context-note reveal">
          <h3>3 exigences \u00e0 respecter</h3>
          <p><strong>1.</strong> Facture au format XML l\u00e9gal TEIF.<br>
             <strong>2.</strong> Transmission &amp; validation via la TTN.<br>
             <strong>3.</strong> Signature \u00e9lectronique \u00e0 valeur probante.</p>
        </div>
      </div>
    </div>
  </div>

  <!-- SOLUTION -->
  <div class="sec bg-soft">
    <div class="wrap">
      <div class="sec-head reveal">
        <span class="eyebrow">La solution</span>
        <h2>Tout le cycle de la facture, sur une seule plateforme</h2>
        <div class="goldline"></div>
      </div>
      <div class="cards">
        <div class="card reveal">
          <div class="ico"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><path d="M14 2v6h6M9 13h6M9 17h6"/></svg></div>
          <h3>G\u00e9n\u00e9ration au format TEIF</h3>
          <p>Vos factures produites directement dans le format XML l\u00e9gal, sans ressaisie ni conversion manuelle.</p>
        </div>
        <div class="card reveal">
          <div class="ico"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><path d="m9 12 2 2 4-4"/></svg></div>
          <h3>Signature certifi\u00e9e</h3>
          <p>Int\u00e9gration TunTrust / DIGIGO pour une signature \u00e9lectronique \u00e0 pleine valeur probante et conforme.</p>
        </div>
        <div class="card reveal">
          <div class="ico"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 2 11 13M22 2l-7 20-4-9-9-4 20-7z"/></svg></div>
          <h3>Transmission TTN / El Fatoora</h3>
          <p>Envoi et validation automatiques aupr\u00e8s de la plateforme officielle, avec retour de statut imm\u00e9diat.</p>
        </div>
        <div class="card reveal">
          <div class="ico"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 3v18h18M7 14l4-4 3 3 5-6"/></svg></div>
          <h3>Suivi en temps r\u00e9el</h3>
          <p>Le statut de chaque facture \u2014 \u00e9mise, sign\u00e9e, valid\u00e9e, rejet\u00e9e \u2014 sur un tableau de bord unique.</p>
        </div>
        <div class="card reveal">
          <div class="ico"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="14" y="14" width="7" height="7" rx="1"/><path d="M7 10v4a2 2 0 0 0 2 2h5"/></svg></div>
          <h3>Connecteur ERP</h3>
          <p>Synchronisation avec votre syst\u00e8me existant via import CSV, Excel, XML ou JSON. La grande diff\u00e9rence LOGIMES.</p>
        </div>
        <div class="card reveal">
          <div class="ico"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg></div>
          <h3>Archivage s\u00e9curis\u00e9</h3>
          <p>Conservation conforme de vos factures et de leurs justificatifs, accessibles et exportables \u00e0 tout moment.</p>
        </div>
      </div>
    </div>
  </div>

  <!-- POURQUOI LOGIMES -->
  <div class="sec">
    <div class="wrap">
      <div class="why">
        <div class="lead-col reveal">
          <span class="eyebrow">Notre diff\u00e9rence</span>
          <h2 style="font-size:clamp(1.6rem,3.4vw,2.2rem);margin:14px 0 4px">Pourquoi LOGIMES</h2>
          <div class="goldline" style="margin:8px 0 18px"></div>
          <p>Nous ne sommes pas un simple \u00e9diteur de factures. LOGIMES int\u00e8gre des ERP et des syst\u00e8mes MES dans l'industrie tunisienne depuis des ann\u00e9es. Notre plateforme est n\u00e9e de cette expertise : elle se connecte r\u00e9ellement \u00e0 votre syst\u00e8me d'information, au lieu de vous imposer une saisie parall\u00e8le.</p>
          <ul>
            <li><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="m20 6-11 11-5-5"/></svg><span>Expertise ERP&nbsp;/&nbsp;MES reconnue et d\u00e9ploy\u00e9e sur le terrain.</span></li>
            <li><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="m20 6-11 11-5-5"/></svg><span>Conformit\u00e9 pens\u00e9e par des int\u00e9grateurs, pas seulement des juristes.</span></li>
            <li><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="m20 6-11 11-5-5"/></svg><span>Accompagnement humain, en Tunisie, dans votre langue.</span></li>
          </ul>
        </div>
        <div class="why-panel reveal">
          <h3>Une expertise \u00e9prouv\u00e9e sur le terrain</h3>
          <p>Nos solutions ERP &amp; MES sont d\u00e9ploy\u00e9es chez des industriels tunisiens de r\u00e9f\u00e9rence.</p>
          <div class="logos-row">
            <span class="chip">KARMEX</span>
            <span class="chip">TPM</span>
            <span class="chip">ID ZAMAC</span>
            <span class="chip">WMT</span>
            <span class="chip">SEKKINOX</span>
          </div>
          <p style="margin-top:24px;margin-bottom:0;font-size:.85rem;color:rgba(255,255,255,.6)">Assessor SIRI certifi\u00e9 INCIT \u00b7 ID : SIRI150625SN001</p>
        </div>
      </div>
    </div>
  </div>

  <!-- POUR QUI -->
  <div class="sec bg-soft">
    <div class="wrap">
      <div class="sec-head reveal">
        <span class="eyebrow">Pour qui</span>
        <h2>Une offre adapt\u00e9e \u00e0 chaque entreprise</h2>
        <div class="goldline"></div>
      </div>
      <div class="aud">
        <div class="card reveal">
          <div class="ico"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M22 21v-2a4 4 0 0 0-3-3.87"/></svg></div>
          <h3>Soci\u00e9t\u00e9s de services</h3>
          <p>Facturation r\u00e9currente simplifi\u00e9e et conforme.</p>
        </div>
        <div class="card reveal">
          <div class="ico"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 10 12 5 2 10l10 5 10-5z"/><path d="M6 12v5c0 1 2.7 3 6 3s6-2 6-3v-5"/></svg></div>
          <h3>Centres de formation</h3>
          <p>Gestion des conventions et des factures clients.</p>
        </div>
        <div class="card reveal">
          <div class="ico"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 21h18M5 21V7l7-4 7 4v14M9 21v-6h6v6"/></svg></div>
          <h3>PME &amp; PMI</h3>
          <p>Mise en conformit\u00e9 rapide, sans refonte du SI.</p>
        </div>
        <div class="card reveal">
          <div class="ico"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M2 20h20M4 20V8l6-4v16M14 20V10l6-2v12M8 12h.01M8 16h.01M17 13h.01M17 16h.01"/></svg></div>
          <h3>Industriels</h3>
          <p>Connexion directe \u00e0 l'ERP de production.</p>
        </div>
      </div>
    </div>
  </div>

  <!-- COMMENT CA MARCHE -->
  <div class="sec">
    <div class="wrap">
      <div class="sec-head reveal">
        <span class="eyebrow">Comment \u00e7a marche</span>
        <h2>Op\u00e9rationnel en 3 \u00e9tapes</h2>
        <div class="goldline"></div>
      </div>
      <div class="steps">
        <div class="step reveal">
          <h3>Vous cr\u00e9ez votre compte</h3>
          <p>Inscription sur la plateforme DAS Cloud, en quelques minutes.</p>
        </div>
        <div class="step reveal">
          <h3>Vous importez ou connectez</h3>
          <p>Saisie directe de vos factures ou synchronisation via le connecteur ERP.</p>
        </div>
        <div class="step reveal">
          <h3>La plateforme s'occupe du reste</h3>
          <p>Signature, transmission \u00e0 la TTN et suivi du statut, automatiquement.</p>
        </div>
      </div>
    </div>
  </div>

  <!-- TARIFICATION -->
  <div class="sec bg-soft">
    <div class="wrap">
      <div class="sec-head reveal" style="max-width:none;text-align:center;margin-left:auto;margin-right:auto">
        <span class="eyebrow" style="justify-content:center">Tarification</span>
        <h2>Une offre adapt\u00e9e \u00e0 votre volume de factures</h2>
        <div class="goldline" style="margin:0 auto"></div>
        <p style="margin:0 auto;max-width:60ch">Des tarifs annuels clairs, sans surprise. Vous ne payez que ce dont vous avez besoin et changez de palier quand votre activit\u00e9 grandit.</p>
      </div>

      <div class="pricing">

        <div class="price-card reveal">
          <div class="price-tier">Flex</div>
          <div class="price-tier-sub">Pour les micro-entreprises et volumes r\u00e9duits.</div>
          <div class="price-amount"><span class="num">250</span><span class="cur">TND</span></div>
          <div class="price-period">HT / an</div>
          <div class="price-quota">30 factures incluses / an</div>
          <div class="price-over">Puis 5 TND / facture suppl\u00e9mentaire</div>
          <ul class="price-feats">
            <li><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="m20 6-11 11-5-5"/></svg>G\u00e9n\u00e9ration au format TEIF</li>
            <li><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="m20 6-11 11-5-5"/></svg>Signature TunTrust</li>
            <li><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="m20 6-11 11-5-5"/></svg>Transmission TTN &amp; suivi</li>
            <li class="off"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M18 6 6 18M6 6l12 12"/></svg>Connecteur ERP</li>
          </ul>
          <a class="btn btn-outline" href="http://das-cloud.com/login" target="_blank" rel="noopener">Commencer</a>
        </div>

        <div class="price-card reveal">
          <div class="price-tier">Connect</div>
          <div class="price-tier-sub">Pour les PME \u00e0 facturation r\u00e9guli\u00e8re.</div>
          <div class="price-amount"><span class="num">600</span><span class="cur">TND</span></div>
          <div class="price-period">HT / an</div>
          <div class="price-quota">100 factures incluses / an</div>
          <div class="price-over">Puis 3 TND / facture suppl\u00e9mentaire</div>
          <ul class="price-feats">
            <li><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="m20 6-11 11-5-5"/></svg>Tout le palier <b>Flex</b></li>
            <li><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="m20 6-11 11-5-5"/></svg>Volume \u00e9tendu (100 factures)</li>
            <li><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="m20 6-11 11-5-5"/></svg>Support prioritaire</li>
            <li class="off"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M18 6 6 18M6 6l12 12"/></svg>Connecteur ERP</li>
          </ul>
          <a class="btn btn-outline" href="http://das-cloud.com/login" target="_blank" rel="noopener">Choisir Connect</a>
        </div>

        <div class="price-card popular reveal">
          <span class="price-badge">Le plus choisi</span>
          <div class="price-tier">Business</div>
          <div class="price-tier-sub">Pour connecter votre ERP et industrialiser.</div>
          <div class="price-amount"><span class="num">1 200</span><span class="cur">TND</span></div>
          <div class="price-period">HT / an</div>
          <div class="price-quota">400 factures incluses / an</div>
          <div class="price-over">Puis 2 TND / facture suppl\u00e9mentaire</div>
          <ul class="price-feats">
            <li><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="m20 6-11 11-5-5"/></svg>Tout le palier <b>Connect</b></li>
            <li><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="m20 6-11 11-5-5"/></svg><b>Connecteur ERP</b> (CSV, Excel, XML, JSON)</li>
            <li><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="m20 6-11 11-5-5"/></svg>Comptes multi-utilisateurs</li>
          </ul>
          <a class="btn btn-navy" href="http://das-cloud.com/login" target="_blank" rel="noopener">Choisir Business</a>
        </div>

        <div class="price-card reveal">
          <div class="price-tier">Enterprise</div>
          <div class="price-tier-sub">Pour les gros volumes et besoins sur mesure.</div>
          <div class="price-amount"><span class="num">2 400</span><span class="cur">TND+</span></div>
          <div class="price-period">HT / an</div>
          <div class="price-quota">Factures illimit\u00e9es</div>
          <div class="price-over">Aucun d\u00e9passement</div>
          <ul class="price-feats">
            <li><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="m20 6-11 11-5-5"/></svg>Tout le palier <b>Business</b></li>
            <li><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="m20 6-11 11-5-5"/></svg>Volume illimit\u00e9</li>
            <li><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="m20 6-11 11-5-5"/></svg>Accompagnement d\u00e9di\u00e9</li>
          </ul>
          <a class="btn btn-outline" href="https://meetings-eu1.hubspot.com/meetings/mohamed-louati" target="_blank" rel="noopener">Nous contacter</a>
        </div>

      </div>

      <p class="pricing-note reveal">Tarifs indiqu\u00e9s hors taxes, par an. Le <strong>connecteur ERP</strong> est inclus \u00e0 partir du palier Business. Vous pouvez changer de palier \u00e0 tout moment : d\u00e8s que votre volume d\u00e9passe le seuil, le palier sup\u00e9rieur devient plus avantageux.</p>
    </div>
  </div>

  <!-- CTA BAND -->
  <div class="sec">
    <div class="wrap">
      <div class="cta-band">
        <div class="wrap">
          <span class="eyebrow" style="color:var(--gold-soft)">Passez \u00e0 l'action</span>
          <h2>Pr\u00eat \u00e0 passer \u00e0 la facturation \u00e9lectronique conforme&nbsp;?</h2>
          <p>Rejoignez les entreprises tunisiennes qui ont s\u00e9curis\u00e9 leur conformit\u00e9 avec DAS Cloud.</p>
          <div class="hero-actions">
            <a class="btn btn-gold" href="http://das-cloud.com/login" target="_blank" rel="noopener">
              Acc\u00e9der \u00e0 la plateforme
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M7 17L17 7M17 7H8M17 7v9"/></svg>
            </a>
            <a class="btn btn-outline-light" href="https://meetings-eu1.hubspot.com/meetings/mohamed-louati" target="_blank" rel="noopener">Demander une d\u00e9mo</a>
          </div>
        </div>
      </div>
    </div>
  </div>
`;

export default function Landing() {
  const containerRef = useRef(null);

  useEffect(() => {
    const scope = containerRef.current;
    if (!scope) return;

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const revealEls = scope.querySelectorAll('.reveal');

    if (reducedMotion) {
      revealEls.forEach((el) => el.classList.add('in'));
      return;
    }

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('in');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );

    revealEls.forEach((el) => io.observe(el));

    return () => io.disconnect();
  }, []);

  return (
    <>
      <link
        href="https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&family=Space+Grotesk:wght@500;600;700&display=swap"
        rel="stylesheet"
      />
      <style>{FE_STYLES}</style>
      <div
        className="fe-block"
        ref={containerRef}
        dangerouslySetInnerHTML={{ __html: FE_HTML }}
      />
    </>
  );
}